import React, { useCallback, useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useMemo } from "react";
import { TOTAL_STATUS_UNPAID, PACKAGE_STATUS_CANCELED, TOTAL_STATUS_CANCELED, PACKAGE_STATUS_DELIVERED } from "../../../../../utils/constant";
import { Link, useHistory } from "react-router-dom";
import { useIntl, FormattedMessage } from "react-intl";
import { getProductUrl, unitPrice } from "../../../../../../../../utils/product";
import { useLanguage } from "../../../../../../../hooks/common";
import Toast from "../../../../../../../components/toast";
import { addToCarts } from "../../../../../../../../api";
import { useDispatch } from "react-redux";
import Alert from "../../../../../../../components/alert";
import { action_fetch_cart_count } from "../../../../../../../../store/actions/global";
import ReturnOrderEditor from "../../components/return-order";
import { action_fetch_order_detail } from "../../../../../../../../store/actions/pages/customer";
import { setCustomerLoading } from "../../../../../../../../store/actions/pages/customer";


const PackageTop = props =>{
    const { name } = props;

    return <div className={cls.PackageHd}>
        <div className={cls.Name}>
            {name}
        </div>

        <div className={cls.Status}>
            {props?.children}
        </div>
    </div>
}

export const OrderPackageItem = props =>{
    useStyles(cls);
    const { product, isNormalOrder, orderId, orderStatus, packageStatus, isReturn, onReturnEditor, showStatusView = false } = props;
    const language = useLanguage();
    const dispatch = useDispatch();
    const Intl = useIntl();
    const history = useHistory();

    const productUrl = useMemo(() =>{
        if(isReturn){
            return undefined;
        }else{
            if(product){
                return getProductUrl(product?.productId, product?.name, null, null, language)
            }
        }
        return undefined;
    }, [product, isReturn]);

    const sizeColor = useMemo(() =>{
        let str;
        if(product?.size && product?.color){
            str = `${product.size}, ${product.color}`;
        }else if(product?.size){
            str = product.size;
        }else if(product?.color){
            str = product.color;
        }
        return str;
    }, [product]);


    const addProducts = useCallback(async (variantId) =>{
        let params = [{"variantId": variantId,"quantity":'1'}];
        let response = await addToCarts(params);
        if(response?.code === 200){
            Toast(Intl.formatMessage({ id: "add_success", defaultMessage: "Add Success" }));
            dispatch(action_fetch_cart_count());
        }else{
            Alert(response?.result || Intl.formatMessage({ id: "add_failed", defaultMessage: "Add Failed" }));
        }
    }, []);

    const handleReturnClick = useCallback((returnOrderId) =>{
        if(!!returnOrderId){
            history.push(`/user/order/return-detail/${returnOrderId}`);
        }else{
            history.push(`/user/faq/support-ticket?orderid=${orderId}`)
        }
    }, [orderId]);

    return <div className={cls.OrderPackageItem} style={props?.style ? props.style: {}}>
        <div className={cls.OrderPackageCon}>
            <div className={cls.LeftItem}>
                <a href={productUrl} className={cls.ImageLink}>
                    <img src={product?.imageURL} alt={product?.name} />
                    {/* 当包裹的状态为4并且状态为canceled的时候并且产品中存在状态的名字时显示 */}
                    {
                        !showStatusView && product?.statusView && <span className={cls.CanceledStatus}>
                            <span className={cls.Font}>{product.statusView}</span>
                        </span>
                    }
                    {
                        product?.isPreOrder && <span className={cls.PreOrder}>Pre order</span>
                    }
                </a>
            </div>

            <div className={cls.CenterItem}>
                <div className={cls.ProductName}>
                    {
                        product?.isDomesticDelivery && <span className={cls.QuickShipFlag}>
                        <FormattedMessage id="quick_ship" defaultMessage="Quick Ship"/>
                    </span>
                    }
                    <span>
                        {product?.name}
                    </span>
                </div>

                <div className={cls.ProductSku}>SKU:{product?.sku}</div>

                <div className={cls.SizeColor}>{sizeColor} x {product?.qty}</div>
              
            </div>

            <div className={cls.RightItem}>
                <div className={cls.ProductPrice}>{unitPrice(product?.price)}</div>
                
                {
                    !isReturn && <div className={cls.BtnContainer}>
                        {
                            orderStatus === TOTAL_STATUS_CANCELED && packageStatus === PACKAGE_STATUS_CANCELED && <a onClick={() =>addProducts(product?.variantId)} className={cls.RepurChase}><FormattedMessage id="repurchase" defaultMessage="Repurchase" /></a>
                        }
                        
                        {
                            isNormalOrder && <React.Fragment>
                                {
                                    product?.returnStatus === 1 && <a className={cls.Return} onClick={()=>onReturnEditor()}><FormattedMessage id="return" defaultMessage="Return" /></a>
                                }

                                {
                                    product?.returnStatus === 2 && <a className={cls.Return} onClick={()=>handleReturnClick(product?.returnOrderId)}><FormattedMessage id="returning" defaultMessage="Returning" /></a>
                                }
                            </React.Fragment>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
}

const OrderPackageItems = props =>{
    const { producs, isNormalOrder, orderId, packageStatus, orderStatus, onReturnEditor } = props;

    return <div className={cls.OrderPackageItems}>
        {
            producs?.map((product, index) =>(
                <OrderPackageItem key={product?.productId+index} product={product} index={index} isNormalOrder={isNormalOrder} orderId={orderId} packageStatus={packageStatus} orderStatus={orderStatus} onReturnEditor={onReturnEditor} />
            ))
        }
    </div>
}


export default props =>{
    useStyles(cls);
    const { orderDetail, isNormalOrder } = props;
    const Intl = useIntl();
    const [show, setShow] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();

    const logisticsPackageShow = useMemo(() =>{
        return orderDetail?.logistics?.packages?.length > 1;
    }, [orderDetail?.logistics]);

    const getUnpaidPackage = useMemo(() =>{
        return orderDetail?.fulfillmentStatus === TOTAL_STATUS_UNPAID ? Intl.formatMessage({ id: "unpaid", defaultMessage: "Unpaid" }) : orderDetail?.fulfillmentStatusView;
    }, [orderDetail]);

    const onReturnEditor = useCallback(() =>{
        setShow(true);
    }, []);

    const onClose = useCallback((type) =>{
        setShow(false);

        if(type === "refresh"){
            history.push(`/user/faq/support-ticket?orderid=${orderDetail?.id}`);
        }
    }, [orderDetail?.id]);

    const onRefresh = useCallback(async () =>{
        dispatch(setCustomerLoading(true));
        let response = await dispatch(action_fetch_order_detail(orderDetail?.id));
        dispatch(setCustomerLoading(false));

        return response;
    }, []);

    return <div className={cls.OrderPackages}>
        {
            orderDetail?.logistics?.packages?.map((parcel, index) =>(
                <div key={parcel?.name+index} className={`${cls.PackagesContainer} ${logisticsPackageShow ? cls.Packages : ''}`}>
                    {
                        logisticsPackageShow ? <PackageTop name={parcel?.name}>
                            {
                                parcel?.logisticsSupplierWebsiteURL ? <React.Fragment>
                                    <a href={parcel.logisticsSupplierWebsiteURL}>{parcel?.fulfillmentStatusView}</a>
                                </React.Fragment> : <React.Fragment>
                                    {
                                        parcel?.trackingId && <Link to={`/user/order/packageTracking?type=${parcel?.status}&packageId=${parcel?.trackingId}`}>{parcel?.fulfillmentStatusView}</Link>
                                    }
                                </React.Fragment>
                            }
                        </PackageTop> : <PackageTop name={<React.Fragment>
                            <span style={{textTransform: 'capitalize'}}><FormattedMessage id="item" defaultMessage="Item" /></span>
                            {
                                parcel?.products?.length > 1 && <span>(s)</span>
                            }
                        </React.Fragment>}>
                            {getUnpaidPackage}
                        </PackageTop>
                    }

                    <OrderPackageItems 
                        producs={parcel?.products} 
                        isNormalOrder={isNormalOrder} 
                        orderId={orderDetail?.id} 
                        packageStatus={parcel?.status} 
                        orderStatus={orderDetail?.fulfillmentStatus} 
                        onReturnEditor={()=>onReturnEditor(orderDetail.logistics.packages)} 
                    />
                </div>
            ))
        }

        <ReturnOrderEditor 
            show={show} 
            onClose={(flag)=>onClose(flag)} 
            onRefresh={onRefresh} 
            onEditor={(data)=>console.log('data', data)} 
            orderPackages={orderDetail?.logistics?.packages} 
            orderId={orderDetail.id} 
        />
    </div>
}